// "render-url" returns the URL an HTML artifact renders from, rather than being that URL: it
// carries a ticket only the server can mint. See api/get-artifact-render-url.
type ArtifactUrlKind = "content" | "download" | "render-url"

interface ArtifactUrlParams {
  accountAlias: string
  threadId: string
  artifactId: string
}

export function buildArtifactUrl({ accountAlias, threadId, artifactId }: ArtifactUrlParams, kind: ArtifactUrlKind): string {
  return `/api/${encodeURIComponent(accountAlias)}/ai/chat/threads/${encodeURIComponent(threadId)}/artifacts/${encodeURIComponent(artifactId)}/${kind}`
}

interface SharedArtifactUrlParams {
  accountAlias: string
  resourceId: string
}

/**
 * A shared artifact is addressed by its resource, never by the thread it came from — that thread may
 * be gone, and the recipient never had access to it in the first place.
 */
export function buildSharedArtifactUrl({ accountAlias, resourceId }: SharedArtifactUrlParams, kind: ArtifactUrlKind): string {
  return `/api/${encodeURIComponent(accountAlias)}/artifacts/${encodeURIComponent(resourceId)}/${kind}`
}
